<template>
  <section class="sme-container__info">
    <template>
      <div
        v-for="(item,index) in info"
        :key="index"
        class="box">
        <div
          class="table"
          :class="item.class" >
          <div class="th font-14">{{item.title}}</div>
          <div
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.noShow"
            :key="sumIndex"
            class="tr">
            <span class="fw-600">{{ sumItem.name }}</span>
            <span
              v-if="sumItem.type == 'array'"
            >
              <span
                v-for="(sum,index) in sumItem.value"
                :key="'sum'+index"
                v-copy="sum.item">{{sum.item}}<br></span>
            </span>
            <span
              v-else-if="sumItem.value"
              v-copy="sumItem.value">{{sumItem.value}}</span>
            <span
              v-else
              v-copy="showCompare(sumItem, formData[sumItem.field])">
              {{ showCompare(sumItem, formData[sumItem.field]) }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="box">
        <div
          class="table mg-b-10">
          <div class="th">Employee's Compensation Details</div>
          <section>
            <div class="tr">
              <span class="fw-600">	Any Self-Employed Person(s), Partner or Sole Proprietor for your business?</span>
              <span>{{ getOptionName('smeYesNoOptions', ec_detail.self_employed_ind)}}</span>
            </div>
            <section
              v-for="(occ_item,index) in ec_detail.occ_information_list"
              :key="'occ_item'+index">
              <div
                v-if="showOCc"
                class="tr">
                <span class="fw-600">Occupation</span>
                <span v-copy="getSMEOptionName(smeOptions.ec_occupation, occ_item.occ_id)">{{ getSMEOptionName(smeOptions.ec_occupation, occ_item.occ_id)}}</span>
              </div>
              <section
                v-for="(occ_detail_item,index) in occ_item.occ_detail"
                :key="'occ_detail_item'+index">
                <div
                  class="tr">
                  <span class="fw-600">{{ getSMEOptionName(smeOptions.ec_nature, occ_detail_item.nature_time)}}</span>
                  <span v-copy="getOptionName('smeYesNoOptions', occ_detail_item.nature_time_enable)">{{ getOptionName('smeYesNoOptions', occ_detail_item.nature_time_enable)}}</span>
                </div>
                <div class="tr">
                  <span class="fw-600">No. of Employee(s)</span>
                  <span v-copy="occ_detail_item.no_of_employee">{{  occ_detail_item.no_of_employee}}</span>
                </div>
                <div class="tr">
                  <span class="fw-600">Estimated Annual Earnings</span>
                  <span v-copy="occ_detail_item.annual_salary">{{  occ_detail_item.annual_salary}}</span>
                </div>
              </section>
            </section>
          </section>
        </div>
      </div>
    </template>
  </section>

</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinSMEInfo from '@/mixins/smeInfo'
import {mapState} from 'vuex'

export default {
  name: 'cateringInfo',
  mixins: [MixinOptions,MixinSMEInfo],
  props: {
    title: {
      type: Boolean,
      default: true
    },
  },
  data(){
    return{
      // compareData:
    }
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
  },

  methods: {
    showCompare(item, field) {
      var change = field
      return change
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../info";
</style>
